<div class="settings-menu" (click)="onToggle()">
    <mat-icon class="menu-icon">settings</mat-icon>
    <kendo-popup #popup
                 [anchor]="elRef"
                 [anchorAlign]="anchorAlign"
                 [popupAlign]="popupAlign"
                 (anchorViewportLeave)="show = false"
                 *ngIf="show">
        <div #popupContainer class="popup-content">
            <ul>
                <li *ngFor="let item of settingsMenuItems">
                    <app-settings-menu-item *ngIf="item.enabled"
                            [menuItem]="item"></app-settings-menu-item>
                </li>
            </ul>
        </div>
    </kendo-popup>
</div>
